"use strict";

var EventEmitter = require("events").EventEmitter;

var StoresHelper = require("./StoresHelper");

var CHANGE_EVENT = "change";

var AbstractStore = class extends EventEmitter {
	constructor(options) {
		options = options || {};
		super(options);

		if (this.constructor === AbstractStore) {
			throw new TypeError("Cannot construct AbstractStore instances directly!");
		}
	}

	addChangeListener(callback) {
		this.on(CHANGE_EVENT, callback);
	}

	removeChangeListener(callback) {
		this.removeListener(CHANGE_EVENT, callback);
	}

	emitChange() {
		this.emit(CHANGE_EVENT);
	}

	getWizardValue(wizardName, propertyName, tokens) {
		return StoresHelper.getWizardValue(this.get(wizardName), propertyName, tokens);
	}
};

module.exports = AbstractStore;
